import { forwardRef } from 'react';
import clsx from 'clsx';
import { ChevronDown } from '@gjensidige/builders-icons';

import styles from './chevron.module.less';

export type ChevronProps = React.ComponentPropsWithoutRef<'svg'> & {
  open?: boolean;
};

export const Chevron = forwardRef<SVGSVGElement, ChevronProps>(function Chevron(
  { className, open, ...rest },
  ref
) {
  return (
    <ChevronDown
      className={clsx(styles.chevron, className, { [styles.open]: open })}
      ref={ref}
      {...rest}
    />
  );
});
